import axios from "axios";

import {
  LandingPageHelper, LocaleHelper,
  PickProgramPageHelper,
  ProgramBannersHelper,
  QuestionnaireHelper
} from "../components/Utilities/CmsHelpers";

const api = process
  .env
  .REACT_APP_ANT1_CMS_BASE_URL
  .concat(process.env.REACT_APP_ANT1_CMS_API_PATH);

const CMS_REQUEST_TIMEOUT = process.env.REACT_APP_ANT1_CMS_TIMEOUT ?? 10000;

const CmsService = {

  getContent: (page, lng) => {
    return axios
      .get(api.concat(page).concat(!!lng ? "?locale="+lng : ""), {
        timeout: CMS_REQUEST_TIMEOUT,
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.message);
        throw error;
      });
  },

  getLandingPageContent: (lng) => {
    return CmsService.getContent(LandingPageHelper.PAGE_URL, lng);
  },

  getPickProgramPageContent: (lng) => {
    return CmsService.getContent(PickProgramPageHelper.PAGE_URL, lng);
  },

  getProgramBanners: (lng) => {
    return CmsService.getContent(ProgramBannersHelper.PAGE_URL, lng);
  },
  getQuestionnaires: (lng) => {
    return CmsService.getContent(QuestionnaireHelper.PAGE_URL, lng);
  },
  getLocales: ()=>{
    return CmsService.getContent(LocaleHelper.PAGE_URL);
  }
};

export default CmsService;
